import React, { SyntheticEvent, useEffect, useRef } from 'react';
import { Controller } from 'react-hook-form';

import { SelektIkon } from './SelectKomponenter';
import { SelectProps } from './Select.definition';

function Select(props: SelectProps) {
	const { placeholder, name, options, control, className, defaultValue, onOptionSelect, id } = props;
	const ref = useRef(null);

	const getOptionData = () => {
		const opt = ref.current.options[ref.current.selectedIndex];
		onOptionSelect(name, opt.dataset.id, opt.dataset.show);
	};

	const setSelectWidth = (event?: SyntheticEvent) => {
		const target = event ? event.target : ref.current;
		const tempSelect = document.createElement('select');
		const tempOption = document.createElement('option');

		tempOption.textContent = target.options[target.selectedIndex].text;
		tempSelect.style.cssText += 'visibility: hidden; position: fixed;';
		tempSelect.appendChild(tempOption);
		target.after(tempSelect);

		const tempSelectWidth = tempSelect.getBoundingClientRect().width;
		target.style.width = `${tempSelectWidth}px`;
		tempSelect.remove();
	};

	useEffect(() => {
		setSelectWidth();
	}, []);

	//const {breakpoint} = useBreakpoint('lg')

	const renderNativeSelect = (options, onChange, onOptionSelect) => (
		<span
			className={ ['text-left', className].join(' ') }
		>
			<select
				ref={ ref }
				id={ id }
				defaultValue={ defaultValue }
				onChange={ event => {
					onChange(event);

					if (onOptionSelect) {
						getOptionData();
					}
					setSelectWidth(event);
				} }
			>
				{ placeholder ? <option value="" disabled hidden>{ placeholder }</option> : null }
				{ options.map((opt: any, index: number) => {
					const { value, label, optionId, visFelter } = opt;
					return (
						<option
							key={ index }
							value={ value }
							data-id={ optionId }
							data-show={ visFelter }
							id={ 'dropdownvalg_0' + (index + 1) + '0_dim2' }
						>
							{ label }
						</option>
					);
				}) }
			</select>
			<div><SelektIkon /></div>
		</span>
	);

	return (
		<Controller
			render={ ({ onChange }) => (
				renderNativeSelect(options, onChange, onOptionSelect)
			) }
			/*render={({onChange,value}) => (
				breakpoint ==='md' || breakpoint ==='lg' ? <ReactSelect
					className={['text-left', className].join(' ')}
					components={{IndicatorSeparator: null, DropdownIndicator: SelektIkon}}
					placeholder={placeholder}
					onChange={onChange}
					value={value}
					styles={customStyles}
					options={options}
					defaultValue={defaultValue}
					isSearchable={false}
				/> :
					renderNativeSelect(options, onChange)
			)}*/
			name={ name }
			control={ control }

		/>
	);
}

export default Select;